/** Test + diagnostics counters for library view retention (#119 Item B). */

let _libraryBrowserMountCount = 0;
let _foregroundAlbumFetchCount = 0;

export function noteLibraryBrowserMount(): void {
  _libraryBrowserMountCount += 1;
}

export function noteLibraryForegroundAlbumFetch(): void {
  _foregroundAlbumFetchCount += 1;
}

export function getLibraryRetentionMetrics(): {
  libraryBrowserMounts: number;
  foregroundAlbumFetches: number;
} {
  return {
    libraryBrowserMounts: _libraryBrowserMountCount,
    foregroundAlbumFetches: _foregroundAlbumFetchCount,
  };
}

export function resetLibraryRetentionMetricsForTests(): void {
  _libraryBrowserMountCount = 0;
  _foregroundAlbumFetchCount = 0;
}

export function isLocalLibraryRoute(pathname: string): boolean {
  return String(pathname || '').startsWith('/app/local-library');
}
